var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTextProvider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4996 16.0754C27.4996 18.9379 26.0246 21.4754 23.7496 23.0754L22.0746 26.7629C21.6871 27.6004 20.5621 27.7629 19.9746 27.0504L18.1246 24.8254C15.7996 24.8254 13.6621 24.0379 12.0371 22.7254L12.7871 21.8379C18.5621 21.4004 23.1246 16.8254 23.1246 11.2504C23.1246 10.3004 22.9871 9.36289 22.7371 8.46289C25.5746 9.96289 27.4996 12.8129 27.4996 16.0754Z",
    fill: "#206FFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 7.5875C18.9125 4.5875 15.65 2.5 11.875 2.5C6.7 2.5 2.5 6.4125 2.5 11.25C2.5 14.1125 3.975 16.65 6.25 18.25L7.925 21.9375C8.3125 22.775 9.4375 22.925 10.025 22.225L10.7125 21.4L11.875 20C17.05 20 21.25 16.0875 21.25 11.25C21.25 9.9375 20.9375 8.7 20.375 7.5875ZM15 12.1875H8.75C8.2375 12.1875 7.8125 11.7625 7.8125 11.25C7.8125 10.7375 8.2375 10.3125 8.75 10.3125H15C15.5125 10.3125 15.9375 10.7375 15.9375 11.25C15.9375 11.7625 15.5125 12.1875 15 12.1875Z",
    fill: "#206FFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextProvider);
export default __webpack_public_path__ + "static/media/text-provider.b8eeca2e30dfac46c210cee697ef8fa3.svg";
export { ForwardRef as ReactComponent };